import { render, staticRenderFns } from "./PodContainer.vue?vue&type=template&id=ec36bab8&scoped=true"
import script from "./PodContainer.vue?vue&type=script&lang=js"
export * from "./PodContainer.vue?vue&type=script&lang=js"
import "./PodContainer.vue?vue&type=style&index=0&id=ec36bab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec36bab8",
  null
  
)

export default component.exports